/**
 * Al cerrar un diálogo (con Escape, con «Cancelar» o al guardar) el foco del teclado tiene que volver al botón que lo abrió; si no, quien navega con teclado o con lector de pantalla
 * queda perdido al principio de la página. PrimeNG no lo hace, y hay ~170 `<p-dialog>` en la app, así que en vez de tocar cada plantilla se hace aquí, una sola vez: se recuerda el último
 * elemento enfocado FUERA de un diálogo y, cuando la máscara de un diálogo desaparece, se le devuelve el foco (si todavía existe y se puede enfocar).
 */
const MASCARA = '.p-dialog-mask';

function mascarasDe(n: Node): HTMLElement[] {
  if (!(n instanceof HTMLElement)) return [];
  return [...(n.matches(MASCARA) ? [n] : []), ...Array.from(n.querySelectorAll<HTMLElement>(MASCARA))];
}

export function devolverFocoAlCerrarDialogos(doc: Document = document): () => void {
  const quienAbrio = new WeakMap<HTMLElement, HTMLElement>();
  let ultimoFuera: HTMLElement | null = null;
  const alEnfocar = (ev: Event) => {
    const t = ev.target;
    if (t instanceof HTMLElement && t !== doc.body && !t.closest(MASCARA)) ultimoFuera = t;
  };
  doc.addEventListener('focusin', alEnfocar, true);
  const observador = new MutationObserver((cambios) => {
    for (const c of cambios) {
      c.addedNodes.forEach((n) => {
        for (const m of mascarasDe(n)) {
          const activo = doc.activeElement;
          const abre = activo instanceof HTMLElement && activo !== doc.body && !m.contains(activo) ? activo : ultimoFuera;
          if (abre && abre.isConnected) quienAbrio.set(m, abre);
        }
      });
      c.removedNodes.forEach((n) => {
        for (const m of mascarasDe(n)) {
          const destino = quienAbrio.get(m);
          if (!destino) continue;
          quienAbrio.delete(m);
          // Si quedó otro diálogo abierto (uno dentro de otro), el foco es de ese; si no, vuelve a quien abrió.
          setTimeout(() => {
            if (doc.querySelector(MASCARA)) return;
            if (destino.isConnected && !(destino as HTMLButtonElement).disabled) destino.focus({ preventScroll: true });
          }, 0);
        }
      });
    }
  });
  observador.observe(doc.body, { childList: true, subtree: true });
  return () => { observador.disconnect(); doc.removeEventListener('focusin', alEnfocar, true); };
}
